import Button from '../../core/components/Button'
import styled from 'styled-components'

export const NavigateButton = styled(Button)`
  margin-top: 10px;
  margin-bottom: 26px;
`
